import { Outlet } from 'react-router';
import { FaProviders } from './FaProviders';

/**
 * `/fa` 配下の全画面に共通の layout route。
 *
 * provider 群を既存UI（v1）・新UI（v2）の枠より外側で1度だけ mount する。枠ごとに mount すると、
 * 枠をまたいで画面を移るたびに provider が作り直され、会社情報などを取り直してしまう。
 */
function FaContainer() {
  return (
    <FaProviders>
      <Outlet />
    </FaProviders>
  );
}

export { FaContainer };
